import { render, staticRenderFns } from "./TaxDetailsAlert.vue?vue&type=template&id=c274dffa"
import script from "./TaxDetailsAlert.vue?vue&type=script&lang=js"
export * from "./TaxDetailsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports